












































































import {namespace} from 'vuex-class';
import {mixins} from 'vue-class-component';
import GeneralUtil from '@/util/GeneralUtil';
import {User} from '@/models';
import {Component, Prop, Watch, Model, Emit} from 'vue-property-decorator';

@Component
export default class AdvertisementAgreeJoin extends mixins(GeneralUtil) {
  @Prop({type: Boolean, default: false}) marketingYn!: boolean;
  @Prop({type: Boolean, default: false}) smsSendYn!: boolean;
  @Prop({type: String, default: ''}) guestName!: string;
  @Prop({type: String, default: ''}) guestNo!: string;
  @Prop({type: String, default: ''}) hpNo!: string;
  // 로컬 상태 변수 추가
  localMarketingYn = false;
  localSmsSendYn = false;

  // 컴포넌트가 마운트될 때 prop 값으로 로컬 상태 초기화
  created() {
    this.localMarketingYn = this.marketingYn;
    this.localSmsSendYn = this.smsSendYn;
  }

  // prop 값이 변경될 때 로컬 상태 업데이트
  @Watch('marketingYn')
  onMarketingYnChanged(newVal: boolean) {
    this.localMarketingYn = newVal;
  }

  @Watch('smsSendYn')
  onSmsSendYnChanged(newVal: boolean) {
    this.localSmsSendYn = newVal;
  }

  // 로컬 상태가 변경될 때 부모 컴포넌트에 이벤트 발생
  @Watch('localMarketingYn')
  onLocalMarketingYnChanged(newVal: boolean) {
    this.$emit('update:marketingYn', newVal);
  }

  @Watch('localSmsSendYn')
  onLocalSmsSendYnChanged(newVal: boolean) {
    this.$emit('update:smsSendYn', newVal);
  }
}
